import React from 'react';
import {Button, Heading, Table} from 'arag-ui-lib';
import { useHistory } from 'react-router-dom';

const columns = [
    {
        propertyName: 'legalName',
        header: 'Legal Name',
        id: 'legalName',
        sortable: false,
    },
    {
        propertyName: 'brandName',
        header: 'Brand Name',
        id: 'brandName',
        sortable: false,
    },
];

const Producers = (props) => {
    const {loading, producers, handleDelete} = props;
    let history = useHistory();

    return (
        <div>
            <Heading variant="h2" title="Producers"/>
            <div className={'form-group'}>
                <Button
                    variant="primary"
                    label="Create New Producer"
                    arrowDirection="right"
                    onClick={() => {
                        history.push('/new-producer');
                    }}
                />
            </div>
            <Table
                loading={loading}
                striped
                columns={columns}
                data={producers}
                hasActions
                actions={
                    [
                        {
                            key: 'edit',
                            label: 'Edit',
                            callback: (datum) =>  history.push(`/producers/${datum.legalName}`),
                        },
                        {
                            key: 'delete',
                            label: 'Delete',
                            callback: (datum) =>  handleDelete(datum.legalName),
                        },
                    ]
                }
                // accordionItemHeaderFormatter={AccordionHeader}
                // pageSize={pager.limit}
                // totalRecords={pager.count || 0}
                // totalPages={pager.totalPages || 0}
                // page={pager.page}
                // pageSizeOptions={config.listSizeOptions}
                // goAtPrevious={goAtPrevious}
                // goAtNext={goAtNext}
                // goAtStart={goAtStart}
                // goAtEnd={goAtEnd}
                // goAtPage={goAtPage}
                // onPageSizeChange={onPageSizeChange}
            />
        </div>
    );
};

export default Producers;